import { render, staticRenderFns } from "./BusinessMngSolutions.vue?vue&type=template&id=992eef4e&scoped=true"
import script from "./BusinessMngSolutions.vue?vue&type=script&lang=js"
export * from "./BusinessMngSolutions.vue?vue&type=script&lang=js"
import style0 from "./BusinessMngSolutions.vue?vue&type=style&index=0&id=992eef4e&prod&lang=scss&scoped=true"
import style1 from "./BusinessMngSolutions.vue?vue&type=style&index=1&id=992eef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992eef4e",
  null
  
)

export default component.exports